import React, {
  FC, useRef, useState
} from 'react';
import { createPortal } from 'react-dom';
import { toJpeg, toSvg } from 'html-to-image';
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { usePopper } from 'react-popper';
import ButtonComponent from '../../../core/components/button/ButtonComponent';

type PropsType = {
  setIsDownload: (isDownload: boolean) => void
};

const isIOSSafari = !!window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
const isSafari = (navigator.vendor.match(/apple/i) || '').length > 0;

const DownloadTextContainer: FC<PropsType> = ({ setIsDownload }) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const referenceElement = useRef(null);
  const popperElement = useRef(null);

  const { styles } = usePopper(referenceElement.current, popperElement.current, {
    placement: 'top-start',
    strategy: 'fixed',
  });

  const toggleDropdown = () => {
    setIsOpenDropdown((prevState) => !prevState);
  };

  const onClick = ({ ratio, isSvg }: { ratio?: number, isSvg?: boolean }) => {
    toggleDropdown();
    setIsDownload(true);

    window.scrollTo(0, 0);

    setTimeout(() => {
      const pages = document.querySelectorAll('.nodePage');

      let pageStrings: { index: number, dataUrl: string }[] = [];

      const isIndent = document.body.scrollWidth !== window.outerWidth;

      Promise.all(Object.values(pages).map((page: Element, index) => new Promise((resolve) => {
        if (isSvg) {
          toSvg(page as HTMLElement, { ...(ratio ? { pixelRatio: ratio } : {}) }).then((dataUrl) => {
            pageStrings = [...pageStrings, { index, dataUrl }];
            resolve(dataUrl);
          });
        } else if (isSafari || isIOSSafari) {
          html2canvas(page as HTMLElement, {
            ...(isIndent ? { scrollX: -8 } : {}),
            ...(ratio ? { scale: ratio } : {}),
          }).then((canvas) => {
            pageStrings = [...pageStrings, { index, dataUrl: canvas.toDataURL('image/jpeg') }];
            resolve(canvas.toDataURL('image/jpeg'));
          });
        } else {
          toJpeg(page as HTMLElement, { ...(ratio ? { pixelRatio: ratio } : {}) }).then((dataUrl) => {
            pageStrings = [...pageStrings, { index, dataUrl }];
            resolve(dataUrl);
          });
        }
      }))).then(() => {
        const zip = new JSZip();

        const sortingPageStrings = pageStrings.sort((a, b) => {
          if (a.index > b.index) {
            return 1;
          }

          if (a.index < b.index) {
            return -1;
          }

          return 0;
        });

        if (isSvg) {
          // Created svg
          sortingPageStrings.forEach((pageString) => zip.file(
            `file-${pageString.index}.svg`,
            decodeURIComponent(pageString.dataUrl.replace('data:image/svg+xml;charset=utf-8,', '')),
            { base64: false },
          ));
        } else {
          sortingPageStrings.forEach((pageString) => zip.file(
            `file-${pageString.index}.jpeg`,
            pageString.dataUrl.replace('data:image/jpeg;base64,', ''),
            { base64: true },
          ));
        }

        zip.generateAsync({ type: 'blob' })
          .then((content) => {
            saveAs(content, 'archive.zip');
            setIsDownload(false);
          });
      });
    }, 100);
  };

  return (
        <div className="relative">
          <div ref={referenceElement}>
            <ButtonComponent
                text={`Скачать конспект ${isOpenDropdown ? '▲' : '▼'}`}
                onClick={toggleDropdown}
            />
          </div>
          <div style={styles.popper} ref={popperElement}>
            {createPortal(
                <div style={styles.popper} ref={popperElement} className="z-10">
                  {isOpenDropdown && (
                      <div className="bg-white border border-gray shadow-md">
                        <div className="p-16 border-b border-gray cursor-pointer hover:bg-gray" onClick={() => onClick({})}>Скачать конспект</div>
                        <div className="p-16 border-b border-gray cursor-pointer hover:bg-gray" onClick={() => onClick({ ratio: 5 })}>Скачать конспект для печати (2775x3550)</div>
                        <div className="p-16 cursor-pointer hover:bg-gray" onClick={() => onClick({ isSvg: true })}>Скачать конспект в формате SVG</div>
                      </div>
                  )}
                </div>,
                document.body
            )}
          </div>
        </div>
  );
};

export default DownloadTextContainer;
